import { render, staticRenderFns } from "./BuilderAnnotationShapeTool.vue?vue&type=template&id=8f6a0510&scoped=true&"
import script from "./BuilderAnnotationShapeTool.vue?vue&type=script&lang=js&"
export * from "./BuilderAnnotationShapeTool.vue?vue&type=script&lang=js&"
import style0 from "./BuilderAnnotationShapeTool.vue?vue&type=style&index=0&id=8f6a0510&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6a0510",
  null
  
)

export default component.exports